/*
 * @Descripttion: 
 * @version: 
 * @Author: tina.cai
 * @Date: 2024-07-27 14:17:07
 * @LastEditors: tina.cai
 * @LastEditTime: 2024-08-03 23:14:45
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index2',
    component: () => import(/* webpackChunkName: "tikmobileB" */ '@/views/homeB.vue')
  },
  {
    path: '/products',
    name: 'productListB',
    component: () => import(/* webpackChunkName: "productListB" */ '@/views/productListB.vue')
  },
  {
    path: '/product/:id',
    name: 'payCheckoutB',
    component: () => import(/* webpackChunkName: "payCheckoutB" */ '@/views/payCheckoutB.vue')
  },
  {
    path: '/mobile',
    name: 'mobileTopupB',
    component: () => import(/* webpackChunkName: "mobileTopupB" */ '@/views/mobileTopupB.vue')
  },
  {
    path: '/confirm/:gameId/:orderNo',
    name: 'payConfirmB',
    component: () => import(/* webpackChunkName: "payConfirmB" */ '@/views/payConfirmB.vue')
  },
  {
    path: '/payResult',
    name: 'payResultB',
    component: () => import(/* webpackChunkName: "payResultB" */ '@/views/payResultB.vue')
  },
  {
    path: '/invoice',
    name: 'invoiceB',
    component: () => import(/* webpackChunkName: "invoiceB" */ '@/views/invoiceB.vue')
  },
  {
    path: '/policy',
    name: 'rprivacy',
    component: () => import(/* webpackChunkName: "rprivacy" */ '@/views/rprivacy.vue')
  },
  {
    path: '/terms',
    name: 'reula',
    component: () => import(/* webpackChunkName: "reula" */ '@/views/reula.vue')
  },
  {
    path: '/rules',
    name: 'raction',
    component: () => import(/* webpackChunkName: "raction" */ '@/views/raction.vue')
  }
  
]

const routerB = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default routerB
